import { exportExcel } from "@api/stores/salesInvoiceItemReport/exportExcel/path";
import { exportPDF } from "@api/stores/salesInvoiceItemReport/exportPDF/path";
import { exportSinglePDF } from "@api/stores/salesInvoiceItemReport/exportSinglePDF/path";
import { stats } from "@api/stores/salesInvoiceItemReport/stats/path";
import { apiPathFunc } from "@api/util/apiPathFunc";

import type { IExtractParams } from "@routes";

const pathBase = `/stores/:storeId/sales-invoice-item-reports/`;

export type IPathBaseParam = IExtractParams<typeof pathBase>;

export const salesInvoiceItemReport = {
  getAll: apiPathFunc(pathBase),
  stats,
  exportPDF,
  exportExcel,
  exportSinglePDF,
};
